import { encodeParams } from 'mailup-react-helpers'

import apiWrapper from 'Helpers/apiWrapper'

import type {
  ContactOpportunity,
  GetSessionOauth2TokenQsParams,
  MobilePrefixesResponse,
  SessionTokenResponse,
  User,
  UserSetting,
} from 'Types/beAccountSettingsApi'

const endpoints = ((baseURL: string) => {
  return {
    getUserSetting: (idList: number, dataKey: string) =>
      `${baseURL}/api/usersettings/list/${idList}/${encodeURIComponent(
        dataKey,
      )}`,
    upsertUserSettings: (idList: number, dataKey: string) =>
      `${baseURL}/api/usersettings/list/${idList}/${encodeURIComponent(
        dataKey,
      )}`,
    getUser: (idUser: number) => `${baseURL}/api/users/${idUser}`,
    sendContactRequest: `${baseURL}/api/adm/notifyevent/opportunity`,
    // Global
    getMobilePrefixes: `${baseURL}/api/global/config/mobileprefixes`,
    //  Session
    getSessionOauth2Token: (qs: GetSessionOauth2TokenQsParams) =>
      `${baseURL}/api/session/oauth2?${encodeParams(qs) as string}`,
  }
})(process.env.BEACCOUNTSETTINGS_URL as string)

export const beAccountSettingsApiGetUserSetting = async (
  idList: number,
  dataKey: string,
): Promise<UserSetting | null> => {
  const url = endpoints.getUserSetting(idList, dataKey)

  return await apiWrapper({
    method: 'get',
    url,
  }).then((res) => res.data)
}

export const beAccountSettingsApiUpsertUserSettings = async (
  idList: number,
  dataKey: string,
  data: any,
): Promise<UserSetting> => {
  const url = endpoints.upsertUserSettings(idList, dataKey)

  return await apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      DataValue: JSON.stringify(data),
    }),
  }).then((res) => res.data)
}

export const beAccountSettingsApiGetUser = async (
  idUser: number,
): Promise<User | null> => {
  const url = endpoints.getUser(idUser)

  return await apiWrapper({
    method: 'get',
    url,
  }).then((res) => res.data)
}

export const beAccountSettingsApiSendContactRequest = async (
  data: ContactOpportunity,
): Promise<boolean | null> => {
  const url = endpoints.sendContactRequest

  return await apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify(data),
  }).then((res) => res.data)
}

export const beAccountSettingsApiGetMobilePrefixes =
  async (): Promise<MobilePrefixesResponse> => {
    return await apiWrapper({
      method: 'get',
      url: endpoints.getMobilePrefixes,
    }).then((res) => res.data)
  }

export const beAccountSettingsApiGetSessionOauth2Token = async (
  qs: GetSessionOauth2TokenQsParams,
): Promise<SessionTokenResponse> => {
  const response = await fetch(endpoints.getSessionOauth2Token(qs))

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`)
  }

  return await response.json()
}
